import styled from "styled-components";

export const StyledContainer = styled.div`
  max-width: 1440px;
  margin: 0 auto;
`;
